import { Copy, Check } from 'lucide-react';
import { useState } from 'react';
import { cn } from '@/utils/cn';

interface PixQRCodeProps {
  qrCode?: string;
  qrCodeUrl?: string;
  copyPaste?: string;
  className?: string;
}

export function PixQRCode({ qrCode, qrCodeUrl, copyPaste, className }: PixQRCodeProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!copyPaste) return;
    try {
      await navigator.clipboard.writeText(copyPaste);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // clipboard not available
    }
  };

  return (
    <div className={cn('flex flex-col items-center gap-4', className)}>
      {qrCodeUrl && (
        <img
          src={qrCodeUrl}
          alt="QR Code PIX"
          className="w-48 h-48 rounded-lg border border-gray-200"
        />
      )}
      {qrCode && !qrCodeUrl && (
        <div
          className="w-48 h-48 rounded-lg border border-gray-200 bg-white flex items-center justify-center text-xs text-gray-400"
        >
          QR Code
        </div>
      )}
      {copyPaste && (
        <div className="w-full max-w-sm">
          <label className="text-xs text-gray-500 mb-1 block">
            Código PIX Copia e Cola
          </label>
          <div className="flex gap-2">
            <input
              type="text"
              readOnly
              value={copyPaste}
              className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-xs bg-gray-50"
            />
            <button
              onClick={handleCopy}
              className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors"
              aria-label="Copiar código PIX"
            >
              {copied ? <Check size={16} className="text-green-600" /> : <Copy size={16} />}
            </button>
          </div>
          {copied && (
            <p className="text-xs text-green-600 mt-1">Código copiado!</p>
          )}
        </div>
      )}
    </div>
  );
}
